import { createSlice } from '@reduxjs/toolkit';

import { dispatchOrders } from "../../apis";
import { getFabricLabelsDispatch } from './apis';

export const dispatchPlatform = createSlice({
  name: "dispatch",
  initialState: {
    loading: false,
    error: "",
    dispatchOrdersSuccess: false,
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dispatchOrders.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(dispatchOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.dispatchOrdersSuccess = true;
    });
    builder.addCase(dispatchOrders.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
  extraReducers: (builder) => {
    builder.addCase(getFabricLabelsDispatch.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getFabricLabelsDispatch.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getFabricLabelsDispatch.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export const { clear } = dispatchPlatform.actions;

export default dispatchPlatform.reducer;